module.exports = __webpack_public_path__ + "img/header_bg.c3ec27c.webp";